/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : pgmIdUtil.ts
// 설명 : 호출프로그램ID(callPgmId = ZA_MENU.CALL_PGM_ID = tab.url, 예: 'ba/K1001M1')에서 화면ID('K1001M1', 대문자)를 뽑는 유틸.
//  - 각 화면은 programId를 직접 적지 않고 ComponentRenderer가 넘겨주는 callPgmId를 그대로 식별키로 씀
//    (그리드 레이아웃 ZA_USER_GRID.PGM_ID, 그리드 등록/분할화면 저장키, 탭 닫기 등).
//  - 모듈 접두어 없는 화면ID가 필요한 곳(엑셀 파일명, DD/그리드 레퍼런스 조회 키인 MENU_ID 대체값 등)만 pgmIdOf()를 씀.
/////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * callPgmId에서 화면ID(대문자)를 뽑습니다. 예) 'ba/K1001M1' -> 'K1001M1', 'popup/H2001R1?x=1' -> 'H2001R1', 없으면 ''
 */
export const pgmIdOf = (callPgmId?: string): string => {
  const base = String(callPgmId || '').split('?')[0].trim();
  return (base.includes('/') ? base.slice(base.lastIndexOf('/') + 1) : base).toUpperCase();
};
